import EventsAPI from "./EventsAPI";

export const sendStartedSwapEvent = () => {
  EventsAPI.trackCustomerEvent("start_preview_and_swap");
};

export const sendCompletedSwapEvent = (pageSource) => {
  EventsAPI.trackCustomerEvent("complete_preview_and_swap", pageSource);
};
